import React from "react"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import Paper from "@material-ui/core/Paper"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"

// Material-UI Icon
import PersonIcon from '@material-ui/icons/Person'
import GroupIcon from '@material-ui/icons/Group'
import EmailIcon from '@material-ui/icons/Email'
import WarningIcon from '@material-ui/icons/Warning'
import ClearIcon from '@material-ui/icons/Clear'

// Global Function
import {avatarTypeColor} from '../../global/avatarColor'

// Custom Style
import {whiteColor, redColor, grayColor} from '../../styles/jss/cmsMainStyle'
import recipientChipStyle from "../../styles/jss/components/chip/recipientChipStyle"


const ChipContentTypography = withStyles({
	root: {
		"fontSize": 12,
		"fontWeight": 400,
		"color": grayColor[10],
	},
}) (Typography)


const useStyles = makeStyles(theme => recipientChipStyle(theme))

const RecipientChip = props => {
	const classes = useStyles()
	const {id, rcptType, rcptName, actionButton, removeAction, handleRecipientClipClick} = props

	return (
		// <Chip
		// 	key={id}
		// 	avatar={
		// 		<Avatar
		// 			className={classes.avatar}
		// 			style={{
		// 				'--avatar-color': avatarTypeColor(rcptType)
		// 			}}
		// 		>
		// 			{rcptType === "USER" ? <PersonIcon fontSize="small" /> : rcptType === "USERGROUP" ? <GroupIcon fontSize="small" /> : rcptType === "EMAIL" ? <EmailIcon fontSize="small" /> : <WarningIcon fontSize="small" />}
					
		// 		</Avatar>
		// 	}
		// 	label={rcptName}
		// 	variant="outlined"
		// 	className={classes.chip}
		// 	clickable
		// 	// onDelete={removeAction !== null ? removeAction : ""}
		// 	onDelete={removeAction}
		// 	onClick={rcptType === "USERGROUP" ? handleRecipientClipClick : rcptType === "USER" ? null : null}
		// />



		<div className={classes.root}>
			<Paper variant="outlined" className={classes.paper} onClick={rcptType === "USERGROUP" ? handleRecipientClipClick : rcptType === "USER" ? null : null}>
		  		<Avatar
		  			className={classes.avatar}
					style={{
						'--avatar-color': avatarTypeColor(rcptType)
					}}
				>
					{rcptType === "USER" ? <PersonIcon fontSize="small" /> : rcptType === "USERGROUP" ? <GroupIcon fontSize="small" /> : rcptType === "EMAIL" ? <EmailIcon fontSize="small" /> : <WarningIcon fontSize="small" />}
				</Avatar>
  
		  		<div className={classes.chipContent}>
				  <ChipContentTypography>{rcptName}</ChipContentTypography>
				</div>
  
				<div className={classes.actionBtnGroup}>
					{
						actionButton ?
							actionButton.map(res => {
								return (
									<Avatar className={classes.actionBtn}>
										<IconButton 
											className={classes.actionBtnIcon}
											aria-label={res.id}
											onClick={res.action}
											style={{
												'--icon-color': res.active ? redColor[5] : whiteColor
											}}
										>
											{res.icon}
										</IconButton>
									</Avatar>
								)
							})
						: ""
					}

					{
						removeAction ?
							<Avatar className={classes.actionBtn}>
								<IconButton 
									className={classes.actionBtnIcon}
									aria-label="remove"
									onClick={removeAction}
									style={{
										'--icon-color': whiteColor
									}}
								>
									<ClearIcon fontSize="small"	/>
								</IconButton>
							</Avatar>
						: ""
					}
					
				</div>
			</Paper>
		</div>

	)
}


export default RecipientChip